( function () {
	'use strict';

	function formulaService ( mathOperatorService ) {
		// removes empty tokens
		function emptyFilter ( token ) {
			return token !== '';
		}

		// tokenizes comma-separated string
		function cleanUp ( data ) {
			return data.split( ';' ).filter( emptyFilter );
		}

		// splits elements after the indicator
		function tokenizeAfterIndicator ( formula ) {
			return cleanUp( formula.replace( /:\]/g, ':];' ) );
		}

		// splits elements prior to indicator
		function tokenizeBeforeIndicator ( formula ) {
			var postTokenHolder = [];

			tokenizeAfterIndicator( formula ).map( function ( token ) {
				postTokenHolder = postTokenHolder.concat( cleanUp( token.replace( /\[:/g, ';[:' ) ) );
			} );
			return postTokenHolder;
		}

		// extracts `[:` and `:]` identifiers from the indicator representation
		function removeIndicatorIdentifiers ( tokenCollection, token ) {
			tokenCollection.push( token.replace( /:\]/g, '' ).replace( /\[:/g, '' ) );
		}

		function maskOperators ( processedArray, token ) {
			var optrTokenItem = token;

			mathOperatorService.getFilters().map( function ( mask ) {
				optrTokenItem = optrTokenItem.replace( mask.pattern, mask.replace );
			} );
			return processedArray.concat( cleanUp( optrTokenItem ) );
		}

		// split formula oparators
		function tokenizeOperators ( formula ) {
			var rawArray       = tokenizeBeforeIndicator( formula );
			var processedArray = [];

			rawArray.map( function ( token ) {
				if ( token.indexOf( '[:' ) > -1 ) {
					removeIndicatorIdentifiers( processedArray, token );
				} else {
					processedArray = maskOperators( processedArray, token );
				}
			} );

			return processedArray;
		}

		// adds number input into the formula element stack
		function addNumToModel ( model, numberId, value ) {
			model.push( {
				'key'     : numberId,
				'isNum'   : true,
				'display' : value,
				'value'   : {
					'id' : value
				}
			} );
		}

		function wrapNumber ( model, running, token ) {
			running.count = running.count + 1;
			var numId     = 'num' + running.count;

			addNumToModel( model, numId, token );
			return numId;
		}

		function optrFilterTokenMapper ( display ) {
			return display.key;
		}

		function processToken ( token, model, running ) {
			if ( mathOperatorService.getDisplay().map( optrFilterTokenMapper ).join( '' ).indexOf( token ) > -1 ) {
				return token;
			} else if ( token.indexOf( '-' ) < 0 && angular.isNumber( Number( token ) ) ) {
				return wrapNumber( model, running, token );
			}

			return ( model.filter( function ( math ) {
				return math.value.id === token;
			} )[ 0 ] || {} ).key;
		}

		function deepValidate ( formula ) {
			var dummyFormula = formula
				// replace [:guid:] with 1
				.replace( /\[:([\w]+\-)+([\w]+):\]/g, '1' )
				// replace decimals with 1
				.replace( /\d+(\.\d{1,4})?/g, '1' )
				// replace math functions with (
				.replace( /[\w]+\(/g, '(' );

			var singleEquationChecker = /[\w]+(\,|\+|\-|\*|\/)[\w]+/g;

			// check if contains single equation
			while ( dummyFormula.match( singleEquationChecker ) ) {
				dummyFormula = dummyFormula
					// replace single equation with 1
					.replace( singleEquationChecker, '1' )
					// replace value enclosed in parenthesis with 1
					.replace( /\([\w]+\)/g, '1' )
					// replace whole value with 1
					.replace( /[\w]+/g, '1' );
			}

			dummyFormula = dummyFormula.replace( /[\w]+/g, '1' );

			// after filtering it should only produce '1' or ''
			return {
				'isValid'   : dummyFormula === '1' || dummyFormula === '',
				'errorData' : dummyFormula.replace( /[\w]+/g, '' ).split( '' )
			};
		}

		function validate ( formula ) {
			var hasJoinedValues
				// checks if there are values next to each other
				= formula.match( /\:\]\[\:/g )
				// checks if there are numbers next to a value
				|| formula.match( /\:\][\w]+/g )
				// checks if there are values next to a number
				|| formula.match( /[\w]+\:\[/g );

			if ( hasJoinedValues ) {
				return {
					'isValid'   : false,
					'errorData' : 'Values must be separated by an operator.'
				};
			}

			return deepValidate( formula );
		}

		// replaces values with key mapped to them
		function aliasValues ( model, formula ) {
			var running = {
				'count' : 0
			};

			var tokenList = tokenizeOperators( formula ).map( function ( token ) {
				return processToken( token, model, running );
			} );

			return tokenList;
		}

		return {
			'addNumToModel' : addNumToModel,
			'aliasValues'   : aliasValues,
			'validate'      : validate
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'formulaService', formulaService );

	formulaService.$inject = [ 'mathOperatorService' ];
} )( );
